// Runtime configuration for the frontend.
//
// API_BASE should be the public URL of your Render backend once deployed,
// e.g. "https://first-15-moves-api.onrender.com".
//
// If left blank, the app automatically falls back to a browser Stockfish
// Web Worker (vendor/stockfish/stockfish.js) — useful for local development
// or if the backend is down.
export const CONFIG = {
  // Set this to your Render URL after deploying the backend, e.g.:
  //   API_BASE: "https://first-15-moves-api.onrender.com"
  // Left blank = use the browser Stockfish worker fallback.
  API_BASE: "https://first-15-moves-api.onrender.com",

  // Default analysis depth for move critique (interactive, must feel snappy).
  ANALYSIS_DEPTH: 12,

  // Default depth for computer replies when off-book. Lower = more human-ish.
  REPLY_DEPTH: 10,

  // Timeout for a single API call before we give up and fall back.
  API_TIMEOUT_MS: 6000,

  // Phase 1: Italian first-four-moves graph. When true, Italian book/plan
  // lookup is position-keyed.
  ITALIAN_GRAPH: true,

  // Phase 2: every opening uses the position graph. Non-Italian courses
  // are shallow (limited book coverage) until Phase 4.
  POSITION_GRAPH: true,
};
